export default {
    "UPDATE_TRIGGER_FORM_DATA": "UPDATE_TRIGGER_FORM_DATA",
    "UPDATE_TRIGGER_TABLE_DATA": "UPDATE_TRIGGER_TABLE_DATA",
    "UPDATED_TRIGGER": "UPDATED_TRIGGER",
    "CREATED_TRIGGER": "CREATED_TRIGGER",
    "DELETED_TRIGGER": "DELETED_TRIGGER",
    "FETCHED_ERRORS": "FETCHED_ERRORS",
    "FETCHED_SUBSEQUENT_ERRORS": "FETCHED_SUBSEQUENT_ERRORS",
    "ERRORS_SEEN": "ERRORS_SEEN"
}